import axios from 'axios';

export const loadTemplates = providerId => (
	axios.get(`/providers/${providerId}/appointment_template`, {
		params: {
			filter: JSON.stringify({
				include: 'appointment_template_item'
			})
		}
	})
);

export const createTemplate = template => (
	axios.post('/appointment_templates', template)
);

export const saveTemplate = template => (
	axios.put(`/appointment_templates/${template.id}`, template)
);

export const deleteTemplate = template => (
	axios.delete(`/appointment_templates/${template.id}`)
);

export const loadTemplateItems = template => (
	axios.get(`/appointment_templates/${template.id}/appointment_template_item`)
);

export const createTemplateItem = templateItem => (
	axios.post('/appointment_template_items', templateItem)
);

export const saveTemplateItem = templateItem => (
	axios.put(`/appointment_template_items/${templateItem.id}`, templateItem)
);

export const deleteTemplateItem = templateItem => (
	axios.delete(`/appointment_template_items/${templateItem.id}`)
);
